<template>
  <div class="news-detail-layout">
    <div class="content-layout">
      <div class="flex">
        <span class="btn-back" @click="onBack">{{ $t('back') }}</span>
        <!-- <div class="last">近期新闻</div>
        <div class="line-h"></div>
        <div class="last-news-root">
          <div v-for="(news, index) in lastList" :key="index">
            <div class="time">{{ setTime(news.pubDate) }}</div>
            <div class="sub" @click="onSubClick(news.id)">{{ news.title }}</div>
          </div>
        </div> -->
      </div>
      <div class="content">
        <div class="top">
          <div class="title">{{ respData.contentTitle }}</div>
          <div class="time">{{ respData.contentDate }}</div>
          <div v-if="respData.contentShortTitle" class="info">{{ respData.contentShortTitle }}</div>
          <div class="action-buttons">
            <div v-if="respData.contentOutLink" class="detail-action" @click="onViewOriginal">
              <i class="el-icon-top-right"></i>{{ $t('viewOriginalText') }}
            </div>
            <div class="detail-action" @click="onShare"><i class="el-icon-share"></i>{{ $t('share') }}</div>
          </div>
        </div>
        <!-- <div class="line-h"></div> -->
        <div
          class="content-details"
          style="padding: 20px 0; flex: 1; border-top: 1px solid #ccc"
          v-html="respData.contentDetails"
        ></div>
        <div class="blank"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchRecruitmentDetail } from './model'
export default {
  data() {
    return {
      respData: {},
      lastList: [],
      id: '',
      language: localStorage.getItem('Language')
    }
  },
  mounted() {
    this.id = localStorage.getItem('news_id')
    if (this.id) this.init(this.id)
  },
  beforeDestroy() {
    localStorage.setItem('news_id', '')
  },
  methods: {
    getShareUrl() {
      const route = this.$router.resolve({
        path: '/enterprise-news',
        query: { newsId: this.id, showDetail: true }
      })
      return new URL(route.href, window.location.href).href
    },
    async copyShareUrl(url) {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url)
        return
      }

      const textarea = document.createElement('textarea')
      textarea.value = url
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      const copied = document.execCommand('copy')
      document.body.removeChild(textarea)
      if (!copied) throw new Error('Copy failed')
    },
    async onShare() {
      const url = this.getShareUrl()
      const shareData = {
        title: this.respData.contentTitle || document.title,
        text: this.respData.contentShortTitle || this.respData.contentTitle || '',
        url
      }

      if (navigator.share) {
        try {
          await navigator.share(shareData)
          return
        } catch (error) {
          if (error.name === 'AbortError') return
        }
      }

      try {
        await this.copyShareUrl(url)
        this.$message.success($t('copySuccess'))
      } catch (error) {
        this.$message.error($t('copyFail'))
      }
    },
    onViewOriginal() {
      if (this.respData.contentOutLink) {
        window.open(this.respData.contentOutLink, '_blank')
      }
    },
    onBack() {
      this.$emit('onBack')
    },
    init(id) {
      localStorage.setItem('news_id', id)
      this.id = id
      this.getRecruitmentDetail(id)
      // this.getNewList()
    },
    onSubClick(id) {
      this.init(id)
    },
    async getRecruitmentDetail(id) {
      const resp = await fetchRecruitmentDetail(id)
      this.respData = resp.data
      // this.respData = item
    },
    // async getNewList() {
    //   const resp = await fetchNewList()
    //   this.lastList = resp.data.list
    // },
    setTime(time) {
      if (!time) return ''
      const val = time.match(/(\d{4})-(\d{2})-(\d{2})/)
      if (val) return val[0]
      return time
    }
  }
}
</script>

<style lang="scss" scoped>
$margin-top: 4vh;
.news-detail-layout {
  display: flex;
  justify-content: center;
  width: 100%;
  .content-layout {
    display: flex;
    width: 80vw;
    height: calc(100vh - 16.75vh);
    .flex {
      flex-shrink: 0;
    }
    .btn-back {
      display: inline-block;
      border: 1px solid #999999;
      border-radius: 25px;
      padding: 10px 24px;
      margin-top: $margin-top;
      cursor: pointer;
      margin-bottom: 2vh;

      &::before {
        content: '\e6de';
        font-family: 'element-icons';
      }
    }

    .last {
      font-size: 1.1vw;
      margin-bottom: 2vh;
    }

    .last-news-root {
      width: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .time {
        color: #666666;
        font-size: 16px;
        line-height: 40px;
        height: 40px;
        &::before {
          content: '• ';
        }
      }

      .sub {
        width: 100%;
        font-size: 0.9vw;
        color: #666666;
        margin-left: 10px;
        cursor: pointer;

        &:hover {
          color: #333;
        }
      }
    }

    .content {
      flex: 1;
      padding: 0 40px;
      display: flex;
      flex-direction: column;
      .top {
        // height: 170px;
        display: flex;
        flex-direction: column;
        margin-top: $margin-top;
        // justify-content: space-between;
        // align-items: center;

        .title {
          color: #333;
          font-size: 30px;
          font-weight: bold;
          margin-bottom: 2vh;
          // margin: 10px 0;
        }
        .time {
          margin-bottom: 1.5vh;
        }
        .info {
          color: #333;
          font-size: 20px;
          line-height: 40px;
          margin-bottom: 2vh;
        }
        .action-buttons {
          display: flex;
          gap: 12px;
          margin-bottom: 2vh;
        }
        .detail-action {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          width: 135px;
          height: 42px;
          border: 1px solid #999999;
          border-radius: 25px;
          cursor: pointer;
          i {
            margin-right: 4px;
            font-size: 15px;
          }
        }
      }
      .content-details {
        /deep/ video {
          width: 100%;
        }
      }
      .blank {
        height: 20px;
        min-height: 20px; /* 确保最小高度 */
        display: block;
        border-top: 1px solid #ccc;
      }
      // background: #999999;
    }
  }
}
</style>
